import { useNavigate, useSearchParams, useLocation } from 'react-router';

export default function usePageNavigation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const pageParam = searchParams.get('current');
  const currentPage = pageParam ? parseInt(pageParam, 10) || 1 : 1;

  const navigateToPage = (page: number) => {
    const next = new URLSearchParams(searchParams);
    if (page === 1) {
      next.delete('current');
    } else {
      next.set('current', String(page));
    }
    const query = next.toString();
    navigate(`${location.pathname}${query ? `?${query}` : ''}`);
  };

  return { currentPage, navigateToPage };
}
